// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD4flatnRPThju9ykGoDslXnSh4Uu0bLn0",
  authDomain: "ecommerceseo-f9970.firebaseapp.com",
  projectId: "ecommerceseo-f9970",
  storageBucket: "ecommerceseo-f9970.firebasestorage.app",
  messagingSenderId: "881749480472",
  appId: "1:881749480472:web:7a24d2e2eb49b7aff6df6d"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
